import actions from './actions'

export default function UserssReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      // Do NOT null `editing` here. The user list only mounts the edit dialog
      // while `editing` is truthy, so nulling it on REQUESTING unmounted the
      // dialog the moment Save was clicked - before the response arrived - which
      // destroyed the form and made it impossible to show a save error inline.
      // The dialog is closed explicitly on success by SAVE_USERS_RECIEVED.
      return {
        ...state,
        loading: true,
      }
    case actions.LIST_USERS:
      return {
        ...state,
        result: action.result,
        loading: false,
      }

    case actions.EDIT_USERS:
      return {
        ...state,
        editing: action.result,
        loading: false,
        // Reset, otherwise a prior successful save would immediately close the
        // next dialog that is opened.
        saveSuccess: false,
      }
    case actions.FETCH_PROFILE_SUCCESS:
      return {
        ...state,
        profile: action.result,
        loading: false,
      }
    case actions.FETCH_PROFILE_CLOSE:
      return {
        ...state,
        profile: null,
        loading: false,
      }
    case actions.RESET_USERS:
      return {
        ...state,
        editing: null,
        profile: null,
        loading: false,
        saveSuccess: false,
      }
    case actions.NEW_USERS:
      return {
        ...state,
        editing: { userID: 0 },
        loading: false,
        saveSuccess: false,
      }
    case actions.SAVE_USERS_RECIEVED:
      // Successful save: close the dialog (the list unmounts it when `editing`
      // is null). The duplicate-user-id path never dispatches this, so the
      // dialog stays open there with the inline error.
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: true,
      }
    case actions.CREATE_USERS_RECIEVED ||
      actions.UPDATE_USERS_RECIEVED ||
      actions.DELETE_USERS_RECIEVED:
      return {
        ...state,
        editing: { userID: 0 },
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
        errorField: action.errorField,
        errorTick: action.errorTick,
      }
    default:
      return state
  }
}
